export default {
  WEBSITE: 'http://localhost:8080',
  WEBSITEINTL: 'http://localhost:8080',
  // APIHOST: 'http://dev-uclai-10.persistent.uc.mobvoi-idc.com/cwhCopilot'
  APIHOST: 'https://mobvoi-mw-test.weta365.com/cwhCopilot',
  AVATARURL: 'ws://124.221.111.216:9041/websocket/avatar'
  // AVATARURL: 'wss://streaming-neural-avatar.mobvoi.com/websocket/avatar'
}
